export default {
  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    save: '保存',
    edit: '編集',
    delete: '削除',
    loading: '読み込み中...',
    loadMore: 'もっと読み込む',
    noMore: 'もうない',
    retry: '再試行',
    back: '戻る',
    next: '次へ',
    prev: '前へ',
    submit: '送信',
    reset: 'リセット',
    search: '検索',
    filter: 'フィルター',
    sort: '並べ替え',
    refresh: '更新',
    complete: '完了',
    skip: 'スキップ'
  },
  nav: {
    discover: 'ホーム',
    message: 'メッセージ',
    store: 'ストア',
    mine: 'マイページ',
    recommend: 'おすすめ',
  },
  scene: {
    changeScene: 'シーン切り替え',
    seeAll: 'すべて表示',
    putAway: '折りたたむ',
    selectScene: 'このシーンを選択',
    selected: '選択済み',
    sceneIndex: 'シーン {num}',
  },
  home: {
    title: 'ロールプレイの世界',
    subtitle: 'あなたの物語を始めよう',
    startGame: 'ゲーム開始',
    continueGame: '続ける',
    newGame: '新しいゲーム',
    gameLibrary: 'ライブラリ',
    featured: 'おすすめ',
    popular: '人気',
    recent: '最近',
    search: 'ロールを検索...',
    noData: 'データなし',
    noMoreData: 'これ以上ありません',
    noNetwork: 'ネットワークなし',
    pleaseSelectFilter: 'フィルター条件を選択してください',
  },
  user: {
    login: 'ログイン',
    register: '登録',
    logout: 'ログアウト',
    profile: 'プロフィール',
    avatar: 'アバター',
    nickname: 'ニックネーム',
    email: 'メールアドレス',
    phone: '電話番号',
    password: 'パスワード',
    confirmPassword: 'パスワード確認',
    oldPassword: '以前のパスワード',
    newPassword: '新しいパスワード',
    forgotPassword: 'パスワードを忘れた',
    changePassword: 'パスワード変更',
    bindPhone: '電話番号绑定',
    verifyCode: '確認コード',
    sendCode: 'コード送信',
    level: 'レベル',
    experience: '経験値',
    achievement: '実績',
    history: '履歴'
  },
  game: {
    character: 'キャラクター',
    story: 'ストーリー',
    chapter: 'チャプター',
    scene: 'シーン',
    dialogue: 'ダイアログ',
    choice: '選択',
    inventory: 'インベントリ',
    achievement: '実績',
    save: 'セーブ',
    load: 'ロード',
    restart: 'リスタート',
    pause: '一時停止',
    resume: '再開',
    auto: 'オート',
    speed: '速度',
    volume: '音量',
    settings: 'ゲーム設定'
  },
  message: {
    success: '成功',
    error: 'エラー',
    warning: '警告',
    info: '情報',
    networkError: 'ネットワークエラー',
    serverError: 'サーバーエラー',
    loginSuccess: '登録成功',
    loginFailed: '登録失敗',
    logoutSuccess: 'ログアウト成功',
    saveSuccess: '保存成功',
    saveFailed: '保存失敗',
    deleteConfirm: '削除しますか？',
    operationConfirm: '操作しますか？',
    noNewsYet: 'まだメッセージはありません',
    deleteSuccess: '削除成功',
    deleteFailed: '削除失敗',
    deleteMessage: 'このメッセージを削除してもよろしいですか？この操作は元に戻せません！',
    delete: '削除',
    deleting: '削除中...',
    noMoreData: 'もうメッセージはありません',
    downloading: 'ダウンロード中...',
    downloadSuccess: 'ダウンロード成功',
    downloadFailed: 'ダウンロード失敗',
    copySuccess: 'コピー成功',
    copyFailed: 'コピーに失敗しました',
    reportSuccess: '報告成功',
    reportFailed: '報告失敗',
    translating: '翻訳中...',
    translateSuccess: '翻訳成功',
    translateFailed: '翻訳失敗',
    noMoreMessages: 'もうメッセージはありません',
    loading_more: '読み込み中...',
    pleaseWaitForReply: '削除する前に返信が完了するまでお待ちください',
    pleaseWaitForReplyCurrent: '現在のメッセージの返信が完了するまでお待ちください',
    chat_placeholder: 'を入力してください...',
    setAsBackdropConfirm: '背景に設定',
    setAsBackdropMessage: 'この画像を背景に設定してもよろしいですか？',
    sendFailed: '送信失敗',
    sending: '送信中...',
    introNoYet: 'まだ紹介はありません。チャットして自分で確かめよう。',
    introLabel: '紹介:',
    thinking: '考えている',
    think: '考える',
    translate: '翻訳',
    pleaseUnlock: 'ロックを解除してください',
    tryAgain: '再試行',
    create: '作成',
    free: '無料',
    video: '動画',
    chatMateTyping: 'チャット相手が入力中です...',
    aiAssistant: 'AIアシスタント',
    imageFailed: '画像の生成に失敗しました',
    generatingImage: '画像の生成をお待ちください',
    switchSceneSuccess: 'シーン切り替え成功',
    switchSceneFailed: 'シーン切り替え失敗',
    switchingScene: 'シーン切り替え中...',
    perMessage: '/メッセージ',
    allChat: 'すべてのチャット',
    like: 'いいね',
    saving: '保存中...',
    saved: '保存しました',
    placeholderBlur: 'を入力してください...',
    placeholderFocus: 'チャットを生动的にするために、**内にアクションやシーンの詳細を入力してください。',
    successfulSwitch: '切り替え成功',
    setting: '設定中...',
    uploading: 'アップロード中...',
    purchaseSuccessful: '購入成功',
    processing: '処理中...',
    gettingReward: '奖励获取中...',
    checkIn: 'チェックイン中...',
    deleteHistory: '履歴を削除',
    openingRemarksTitle: '打招呼～',
  },
  success: {
    refreshSuccess: '更新に成功しました',
    copiedToClipboard: 'クリップボードにコピーしました',
    saved: '保存しました',
    uploadSuccess: 'アップロード成功',
    switchSuccess: '切り替え成功',
    thankYouPurchase: 'ご購入ありがとうございます',
  },
  error: {
    notFound: 'ページが見つかりません',
    networkError: 'ネットワークエラー',
    serverError: 'サーバーエラー',
    permissionDenied: '許可が拒否されました',
    goHome: 'ホームへ',
    tryAgain: '再試行',
    uploadFailed: 'アップロード失敗',
    saveFailed: '保存失敗',
    translationFailed: '翻訳失敗',
    generateImageFailed: '画像の生成に失敗しました',
  },
  notFound: {
    title: 'ページが見つかりません',
    description: 'お探しのページは存在しないか、移動されました。',
    goHome: 'ホームへ',
    goBack: '戻る'
  },
  settings: {
    language: '言語',
    theme: 'テーマ',
    notification: '通知',
    privacy: 'プライバシー',
    security: 'セキュリティ',
    about: 'アプリについて',
    version: 'バージョン',
    checkUpdate: 'アップデート確認',
    clearCache: 'キャッシュクリア',
    systemNotification: 'システム通知',
    termsOfService: '利用規約',
    privacyPolicy: 'プライバシーポリシー',
    title: '設定',
    editProfile: 'プロフィール編集',
    faq: 'よくある質問',
    termsOfUse: '利用規約',
    aboutAccount: 'アカウントについて',
    deleteAccount: 'アカウント削除',
    logOut: 'ログアウト',
    logOutTitle: 'ログアウト',
    logOutMessage: 'ログアウトすると、アカウントを再度使用するにはログインする必要があります。ログアウトしてもよろしいですか？',
    confirm: '確認',
    deleteAccountTitle: 'アカウント削除',
    deleteAccountMessage: 'アカウントを削除すると、すべてのデータと情報が消去され、元に戻せません。削除してもよろしいですか？',
    deletingAccount: 'アカウント削除中...',
    accountDeleted: 'アカウント削除成功',
    cacheTitle: 'キャッシュクリア',
    cacheMessage: 'アプリのキャッシュをクリア中、チャット履歴とチャット役は削除されません',
    cleaning: 'クリア中',
    cleaningComplete: 'クリア完了',
  },
  profile: {
    title: 'プロフィール編集',
    yourAvatar: 'アバター',
    whatCallMe: 'AIに何と呼んでほしいか',
    yourName: '名前',
    yourAge: '年齢',
    race: '人種',
    pleaseSelect: '選択してください',
    yourWeight: '体重',
    yourHeight: '身長',
    gender: '性別',
    male: '男性',
    female: '女性',
    neutral: '中立',
    hobby: '趣味',
    pleaseEnter: '入力してください...',
    favoriteFood: '好きな食べ物',
    yourCharacter: 'あなたの性格',
    fantasyAboutOtherHalf: '半分についてのファンタジー',
    uploading: 'アップロード中...',
    enterName: '名前を入力してください',
  },
  report: {
    title: '報告',
    chooseReact: '報告したい内容を選択してください...',
    other: 'その他',
    placeholder: '言いたいことを入力してください...',
    submit: '提出',
    pleaseEnterContent: '内容を入力してください',
  },
  edit: {
    placeholder: 'メッセージを編集...',
    cancel: 'キャンセル',
    save: '保存',
    saving: '保存中...',
  },
  firstConfirmName: {
    canYouTellMeName: '名前を教えてもらえますか？そうすればもっとうまく呼べるようになります！',
    yourName: '名前',
    confirm: '確認',
  },
  toast: {
    translating: '翻訳中...',
    translate: '翻訳',
    translationFailed: '翻訳失敗',
    translationUnlocked: '翻訳ロック解除',
    translationLocked: '翻訳ロック',
    download: 'ダウンロード',
    setAsBackdrop: '背景に設定',
    goChat: 'チャットへ',
  },
  videoPreview: {
    failedToLoad: '動画の読み込みに失敗しました',
  },
  imagePreview: {
    imageLoadFailed: '画像の読み込みに失敗しました',
    preview: '画像プレビュー',
    afterSendIntimacy: 'キャラクターにメッセージを送信すると親密度を獲得します。親密度が指定額に達すると、現在の画像をロック解除できます',
  },
  fqa: {
    title: 'よくある質問',
    description: 'これは製品のよくある質問の継続的に更新されているリストです。リストにない質問がある場合は、Discordにお進みください。',
    howAlWork: {
      title: 'AI彼女はどのように働きますか？',
      content: 'RoleplayGFでは、現実的でファンタジーあふれる関係を作ることがすべてです。最先端のAI技術を使用して、甘やかで無垢な小柄な姫でも、よりolders and more dominantな女性でも、ご自身の好みに合わせて理想的なAI彼女を作成できます。',
    },
    howInteract: {
      title: 'AI彼女と交流する方法は？',
      content: 'スマートシステムと最先端の機械学習により、AI彼女と交流し、親密な関係を持つことができます。彼女はあなたの話を聞き、メッセージに素早く応答し、良い子のように写真のリクエストにも応じます。',
    },
    privacy: {
      title: 'AIフレンドとのプライバシーは？',
      content: 'NSFW AIチャットを使用する場合、あなたの秘密は安全な場所にあります。RoleplayGFでは、プライバシーが最優先です。最先端の安全なデータストレージを使用して、すべての誘惑的なセルフィー、調子の良いテキスト、優しいささやきがあなたと情熱的なパートナーの間でのみ共有されることを保証します。',
    },
    customizeBehavior: {
      title: 'AI彼女の行動をカスタマイズできますか？',
      content: 'あなたの本当の望みを知っているのはあなただけです，这就是为什么您可以自定义整个数字女友体验——从她的曲线到性格特征和小怪癖。想要调情的聊天吗？sweetでslowな関係を探しているなら？現実的なNSFW AI生成器があなたの心の最深部の欲望を満たすことができます。',
    },
  },
  store: {
    tab: 'ストア',
    record: '記録',
    noNetwork: 'ネットワークなし',
    retry: '再試行',
    one: '一つ',
    noConsumptionRecords: 'まだ消費記録はありません',
    transactionHistoryAppear: '取引履歴がここに表示されます',
    rechargeFailTip: '*チャージに失敗した場合は、お問い合わせください >',
    rechargeFailTipStatic: 'チャージに失敗した場合は、',
    contactUsLink: 'お問い合わせ',
    popular: '人気',
    oneTimeOnly: '一回限りの特別価格',
    loading: '読み込み中...',
    noMoreRecords: '記録はこれ以上ありません',
    gift: 'ギフト',
    retentionMessage: 'パートンがあなたの陪伴を必要としています。放棄してもよろしいですか？',
  },
  mine: {
    bindEmail: 'メールアドレスを绑定',
    copyFailed: 'コピーに失敗しました',
    backpackTitle: 'マイバッグ',
    task: 'タスク',
  },
  messagePage: {
    noNetwork: 'ネットワークなし',
  },
  search: {
    recommend: 'おすすめ',
    noNetwork: 'ネットワークなし',
  },
  chatSettings: {
    myGems: 'マイジェム',
    title: 'チャット設定',
    chatModel: 'チャットモデル',
    chatStyle: 'チャットスタイル',
    chatPerspective: 'チャット視点',
    goOnButton: '続行ボタン',
    chatBackground: 'チャット背景',
    awayMessages: '留守番メッセージ',
    disableAwayMessages: '留守番メッセージをオフにする',
    disableAwayMessagesConfirm: 'あなたが留守の間、彼女はあなたにメッセージを送れなくなります。留守番メッセージをオフにしてもよろしいですか？',
    videoFailedToLoad: '動画の読み込みに失敗しました',
  },
  history: {
    deleteHistory: '履歴を削除',
    deleteCharacterHistory: 'このキャラクターの履歴を削除してもよろしいですか？',
  },
  tab: {
    maxSelection: '最大選択可能',
    tags: 'タグ',
  },
  noNewMessage: '新しいメッセージはありません',

  // メッセージ再読み込み
  reloadMessage: {
    title: 'お好みを選択',
    before: '前',
    new: '新しい',
    loading: '読み込み中...',
    noNewMessage: '新しいメッセージはありません',
    tryAgain: '再試行',
    confirm: '確認',
  },

  account: {
    copiedToClipboard: 'クリップボードにコピーしました',
    copyFailed: 'コピーに失敗しました',
    aboutAccount: 'アカウントについて',
    id: 'ID',
    email: 'メールアドレス',
    copied: 'クリップボードにコピーしました',
  },
  rate: {
    title: '評価する',
  },
  awayMessages: {
    disableAwayMessages: '留守番メッセージをオフにする',
    disableConfirm: 'あなたが留守の間、{appName}はあなたにメッセージを送れなくなります。留守番メッセージをオフにしてもよろしいですか？',
  },
  login: {
    title: 'メールアドレスを绑定',
    subtitle: 'アカウントデータのセキュリティを確保するためにメールアドレスを绑定してください。',
    email: 'メールアドレス',
    password: 'パスワード',
    signIn: 'サインイン',
    signUp: 'サインアップ',
    signInWithGoogle: 'Googleでサインイン',
    signInWithEmail: 'メールアドレスでサインイン',
    signInWithPhone: '電話番号でサインイン',
    signInWithApple: 'Appleでサインイン',
    dontHaveAccount: 'アカウントをお持ちでない方？',
    register: '登録',
    bySigningUp: '登録すると、同意了ものとみなされます',
    userAgreement: '利用規約と',
    privacyPolicy: 'プライバシーポリシー。',
    guestMode: 'ゲストモード',
    registerTitle: '登録開始',
    registerSubtitle: 'アカウントデータのセキュリティを確保するためにメールアドレスを绑定してください。',
    alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
    pleaseInputPasswordAndEmail: 'パスワードとメールアドレスを入力してください',
    pleaseInputCorrectEmail: '正しいメールアドレスを入力してください',
    pleaseInputCorrectPassword: 'パスワードは6〜30文字である必要があります',
    male: '男性',
    female: '女性',
    neutral: '中立',
    loggingIn: 'ログイン中...',
    loading: '読み込み中...',
    releaseToRefresh: '離して更新',
    loginFailed: 'ログイン失敗',
    loginSuccess: '登録成功',
    registerFailed: '登録失敗',
    registerSuccess: '登録成功',
    confirm: '確認',
  },
  loadingMore: '更多メッセージを読み込み中...',
  noMoreMessages: 'もうメッセージはありません',

  // VIPページ
  vip: {
    vipUltra: 'VIP Ultra',
    vipPlus: 'VIP Plus',
    restore: '購入を復元',
  },

  // Common dialogs
  dialog: {
    ok: 'OK',
    cancel: 'キャンセル',
    confirm: '確認',
    close: '閉じる',
    retry: '再試行',
    processing: '処理中...',
    contactUs: 'お問い合わせ',
    loginError: 'ログインエラー',
    loginErrorMessage: 'プログラムを終了してアプリケーションを再起動するか、お問い合わせください',
    insufficientEnergy: 'エネルギーが不足しています！',
    insufficientEnergyDesc: '各メッセージは1エネルギーを消費します。1時間ごとに1エネルギーを回復します。',
    insufficientPhysicalStrengthTitle: '体力が不足しています',
    needStrengthToContinue: '会話を続けるには{strength}体力が必要です',
    consumesGems: '{gems}ジェムを消費',
    getStrength: 'エネルギーを得る',
    getGems: 'ジェムを得る',
  },

  // AppNewUser
  appNewUser: {
    title: '新規ユーザー限定',
    ok: 'OK',
  },

  // Rating popup
  rating: {
    title: '評価する',
    description1: 'アプリをお気に入りに登録しましたか？',
    description2: '5つ星で評価してください。',
    rateButton: '今すぐ評価',
  },

  // Version update
  versionUpdate: {
    title: 'バージョン更新',
    updateContent: '更新内容',
    updateNow: '今すぐ更新',
    updating: '更新中...',
    clientOptimization: 'クライアント体験の最適化',
    bugFix: '既知の問題を修正',
  },

  // Message detail page
  messageDetail: {
    free: '無料',
    perMessage: '/メッセージ',
    increaseFavorability: 'メッセージを送信して親密度を上げる',
    album: 'アルバム',
    intro: '紹介',
    noIntro: 'まだ紹介がありません。チャットして自分で見つけてください。',
    tags: 'タグ',
    backToChat: 'チャットに戻る',
    levelFormat: 'Lv.{level}',
    messageCount: '{count} メッセージ',
    chatMateTyping: 'チャット相手が入力中です...',
  },

  // Chat settings
  chatSettingsRight: {
    innerThoughtDesc: 'メッセージを返信する際にキャラクターの心の声を看到她ことができますが、返信速度は遅くなる場合があります。',
  },

  // Chat select menu
  chatSelect: {
    copy: 'コピー',
    report: '報告',
    create: '作成',
    video: '動画',
    translate: '翻訳',
    delete: '削除',
  },

  // Recommended purchases
  recommended: {
    gift: 'ギフト',
  },

  // Thinking toast
  thinkingToast: {
    notAvailable: 'このモデルは思考モードに対応していませんが、開発中です...',
  },

  // First charge popup
  firstCharge: {
    title: '初回チャージ',
    get: '獲得',
    limitedOffer: '期間限定オファー',
    priceFormat: '${price} 獲得',
    congratulations: 'おめでとうございます！あなたは正式なVIP会員になりました~！',
    missOfferTitle: 'このオファーを見送りますか？',
    maybeLater: '後で',
    getNow: '今すぐ獲得',
    benefit1: '130無料ジェムを獲得',
    benefit2: '全キャラクターを解放',
    benefit3: '12倍記憶',
    benefit4: '無制限週間チェックイン',
    benefit5: '広告なし体験',
    buyNow: '今すぐ購入',
  },

  // Check-in center
  checkIn: {
    freeGems: '無料ジェム',
    sevenDayCheckIn: '7日間チェックイン',
    memberExclusive: '会員限定チェックイン：',
    signInTip: '毎日サインインして无尽的奖励を积累',
    getVip: 'VIPを取得',
    plusExtra: 'Plus+{count}',
    getGemsCount: '{count}ジェムを獲得',
    extraDaily: '毎日追加{count}ジェム',
    ultra: 'Ultra',
    signedInTip: '今日は既にサインイン済みです。また明日 المزيد من المكافآت!',
    tasks: 'タスク',
    go: '行く',
    received: '受け取った',
    receive: '受け取る',
    day: '{num}日目',
  },

  // Login page
  loginPage: {
    confirm: '確認',
  },

  // Copyright
  copyright: {
    title: '利用規約',
  },

  // Copy
  copy: {
    copiedToClipboard: 'クリップボードにコピーしました',
    copyFailed: 'コピーに失敗しました',
  },

  // Errors
  errors: {
    networkError: 'ネットワークエラー',
    pleaseSelectFilter: 'フィルター条件を選択してください',
    retry: '再試行',
  },

  // Terms of Service
  terms: {
    intro: '{appName}のウェブサイトを訪問し利用することで、あなたはこれらの利用規約に同意するものとみなされます。',
    section1Title: '1. ウェブサイトの利用',
    section1_1: 'このウェブサイトを利用するには、13歳以上である必要があります。',
    section1_2: 'アカウントの機密性を維持し、アカウント下で発生するすべてのアクティビティについて責任を負うのはあなたです。',
    section1_3: '違法な目的やこれらの条件に違反する目的でウェブサイトを使用することは禁止されています。',
    section2Title: '2. 知的所有権',
    section2_1: '{appName}上のすべてのコンテンツ、機能、特性（テキスト、グラフィック、ロゴ、画像、ソフトウェアを含む）は、{appName}またはそのライセンサーの財産であり、知的財産法によって保護されています。',
    section2_2: '事前の書面による許可なく、ウェブサイトのコンテンツをコピー、再配布、または派生物を作成することは許可されていません。',
    section3Title: '3. プライバシー',
    section3_1: 'ウェブサイトで入手可能なプライバシーポリシーでは、私たちがあなたの個人情報をどのように収集、使用、開示するかを説明しています。',
    section4Title: '4. 保証の否認',
    section4_1: 'ウェブサイトと提供されるサービスは、明示または黙示を問わず、いかなる表明または保証もなく、「現状のまま」および「提供可能な状態」で提供されます。',
    section5Title: '5. 責任の制限',
    section5_1: '法律で 허용される最大限度の範囲で、{appName}は прямой、間接的、偶発的、特殊的または結果的な損害について責任を負いません。',
    section6Title: '6. 補償',
    section6_1: 'あなたは、ウェブサイトの利用から生じる、またはそれに関連する請求、損害、義務、損失、費用（弁護士費用を含む）について、{appName}とその運営者、取締役、従業員を補償し防御することに同意します。',
    section7Title: '7. 準拠法',
    section7_1: 'これらの利用規約は、法の抵触に関する規定を考慮せず、州の法律に従って管理および解釈されます。',
    section8Title: '8. 条件の変更',
    section8_1: '当社は独自の裁量により、いつでもこれらの条件を変更または置換する権利を留保します。',
    section9Title: '9. お問い合わせ',
    section9_1: 'これらの条件についてご質問がある場合は、お問い合わせください。',
  },
}
